<div class="max-width-lg pb-54 header ">
  <app-breadcrumb class="mt-16" [items]="breadcrumbItems"></app-breadcrumb>
  <div class="flex flex-row">
    <mat-icon svgIcon="arrow_back" class="mt-16 mr-24 icon-lg"></mat-icon>
    <div class="flex flex-row w-100-percent">
      <div class="flex flex-col">
        <div class="mat-headline-3 fw-600 mb-16">{{ service?.name }}</div>
        <div class="flex flex-row">
          <ng-container *ngIf="!showStepsLoadingSection;else showActiveHeader">
            <div class="icon-container traffic-light active-icon-bg">
              <mat-icon class="items-center white-fg icon icon-sm" svgIcon="done"></mat-icon>
            </div>
            <div class="mat-subtitle-2 fw-600 ml-10">{{'SERVICE_STATUS.ACTIVE' | transloco}}</div>
          </ng-container>
          <ng-template #showActiveHeader>
            <div class="icon-container accent-1-bg traffic-light">
              <mat-icon svgIcon="change_circle" class="icon-sm white-fg sandbox-setup-progress-icon"></mat-icon>
            </div>
            <div class="mat-subtitle-2 fw-600 ml-10">{{'SERVICE_STATUS.IN_PROGRESS' | transloco}}</div>
          </ng-template>
          <mat-icon svgIcon="more_vert" class="cursor-pointer ml-62"></mat-icon>
        </div>
      </div>
      <div class="vertical-line ml-auto mr-20 h-30"></div>
      <div class="flex flex-col mr-20">
        <div class="mat-headline-6 fw-700">{{trialStatus}}</div>
        <div class="flex flex-row">
          <div class="mat-subtitle-2 fw-500 mr-20">Temenos Retail Banking Lending helps you explore the<br> many
            opportunities for efficient lending and liability.</div>
          <button class="primary mr-10 contact-sales-btn">{{'TOOLBAR.CONTACT_SALES' | transloco}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="flex flex-col max-width-lg white-bg mt-64 mb-64">
  <ng-container *ngIf="!dataLoaded;else showSandboxPage">
    <div class="items-center h-100-percent">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  </ng-container>
  <ng-template #showSandboxPage>
    <ng-container *ngIf="!showStepsLoadingSection;else showDeploymentInProgress">
      <div class="flex flex-col">
        <div class="flex flex-row">
          <div class="mat-headline-4 fw-700 mb-12">{{'BLUEPRINT_SUMMARY.EXPLORE_CUSTOM_SANDBOX' | transloco}}</div>
          <div *ngIf="extendSandbox" class="ml-auto mat-headline-6 fw-700 cursor-pointer extend-sandbox-disabled" (click)="goToExtendSandbox()">{{'BLUEPRINT_SUMMARY.EXTEND.EXTEND_SANDBOX' | transloco}}</div>
        </div>
        <div class="mat-subtitle-2 fw-500 mb-30">
          Here are all the endpoints you need to fully explore your bespoke service.
        </div>
        <div class="flex flex-row justify-between items-center">
          <div class="flex flex-col w-2/6 endpoint-card">
            <img class="w-36 h-34 mb-30" src="/assets/images/View Sandbox.png">
            <div class="mat-headline-5 fw-700 mb-16">{{'BLUEPRINT_SUMMARY.VIEW_SANDBOX' | transloco}}</div>
            <div class="basis-full mat-subtitle-2 fw-400">Access your sandbox in the browser to explore the user
              interface.
            </div>
            <div class="flex flex-row justify-end" *ngFor="let accessTypeEndpoint of accessTypeEndpoints"
              class="cursor-pointer" (click)="openUrl(accessTypeEndpoint.url)">
              <mat-icon svgIcon="open_in_new" class="items-center icon mr-6"></mat-icon>
              <div class="mat-subtitle-2 fw-700 ml-4 mb-0">{{accessTypeEndpoint?.name}}</div>
            </div>
          </div>
          <div class="flex flex-col w-2/6 endpoint-card ml-20 mr-20">
            <img class="w-36 h-34 mb-30" src="/assets/images/Configure Workbench.png">
            <div class="mat-headline-5 fw-700 mb-16">{{'BLUEPRINT_SUMMARY.CONFIGURE_WORKBENCH' | transloco}}</div>
            <div class="basis-full mat-subtitle-2 fw-400">Innovate by using integration & configuration endpoints
              in workbench.
            </div>
            <div *ngFor="let configTypeEndpoint of configTypeEndpoints"
              class="flex flex-col justify-end cursor-pointer" (click)="openUrl(configTypeEndpoint.url)">
              <mat-icon svgIcon="open_in_new" class="items-center icon mr-6"></mat-icon>
              <div class="mat-subtitle-2 fw-700 ml-4 mb-0">{{configTypeEndpoint?.name}}</div>
            </div>
          </div>
          <div class="flex flex-col w-2/6 endpoint-card">
            <img class="h-34 w-34 mb-30" src="/assets/images/API Endpoints.png">
            <div class="basis-full mat-headline-5 fw-700 mb-0">{{'BLUEPRINT_SUMMARY.API_ENDPOINTS' | transloco}}</div>
            <div class="flex flex-col" *ngFor="let exploreTypeEndpoint of exploreTypeEndpoints">
              <mat-divider class="mt-16 mb-16 neutral-blue-6"></mat-divider>
              <div class="flex flex-row cursor-pointer" (click)="openUrl(exploreTypeEndpoint.url)">
                <mat-icon svgIcon="open_in_new" class="items-center icon mr-6"></mat-icon>
                <div class="mat-subtitle-2 fw-700 ml-4 mb-0">{{exploreTypeEndpoint?.name}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="endpoint-card mt-24">
          <div class="flex flex-col">
            <img class="h-34 w-34 mb-30" src="/assets/images/API Endpoints.png">
            <div class="basis-full mat-headline-5 fw-700 mb-32">{{'BLUEPRINT_SUMMARY.EXPLORE_ENDPOINTS' | transloco}}</div>
          </div>          
          <div class="flex flex-row flex-wrap">
            <div class="flex w-2/6" *ngFor="let otherTypeEndpoint of otherTypeEndpoints; let i = index;">
              <div class="flex flex-row cursor-pointer" (click)="openUrl(otherTypeEndpoint.url)">
                <mat-icon svgIcon="open_in_new" class="items-center icon mr-6"></mat-icon>
                <div class="mat-subtitle-2 fw-700 ml-4 mb-0">{{otherTypeEndpoint?.name}}</div>
              </div>
              <mat-divider class="mt-16 mb-16 mr-70 neutral-blue-6" [ngClass]="{'mr-70': (i+1) % 3 !== 0}"></mat-divider>
            </div>
          </div>
        </div>
        
      </div>
    </ng-container>
    <ng-template #showDeploymentInProgress>
      <div class="flex flex-col items-center">
        <div class="flex w-2/6">
          <div class="mat-headline-5 fw-700 mb-32">{{'BLUEPRINT_SUMMARY.CREATING_SANDBOX' | transloco}}</div>
          <mat-progress-bar class="progress-bar-green h-8 progress-bar" mode="determinate" [value]="progressPercentage">
          </mat-progress-bar>
          <div class="mat-caption fw-400 mt-6">Your sandbox is being provisioned. You will be notified
            once created</div>
        </div>

        <div class="md-stepper-horizontal orange">
          <div class="md-step active">
            <div class="items-center md-step-circle">1</div>
            <div class="mat-subtitle-2 fw-500 mt-26">Your Sandbox is being developed at the moment. This might take up
              to 4 hours and we will notify you when it is ready for use.
            </div>
            <div class="md-step-bar-left"></div>
            <div class="md-step-bar-right"></div>
          </div>
          <div class="md-step active">
            <div class="items-center md-step-circle">2</div>
            <div class="mat-subtitle-2 fw-500 mt-26">Meanwhile we suggest you to watch the recommended tutorial videos
              or learn more about SaaS banking in the University. </div>
            <div class="md-step-bar-left"></div>
            <div class="md-step-bar-right"></div>
          </div>
          <div class="md-step active">
            <div class="items-center md-step-circle">3</div>
            <div class="mat-subtitle-2 fw-500 mt-26">Once the Sandbox is ready, you will find a link to this page on
              your home screen. All the Sandbox endpoints will appear here.
            </div>
            <div class="md-step-bar-left"></div>
            <div class="md-step-bar-right"></div>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-template>
</div>

<div *ngIf="extendSandbox && selectedCapabilities?.length > 0" class="flex flex-col pt-64 max-width-lg pale-bg">
  <div class="mat-headline-4 fw-700 mb-10">{{'CAPABILITIES.TITLE' | transloco}} </div>
  <div class="mat-subtitle-2 fw-500">{{'CAPABILITIES.DESCRIPTION' | transloco}} </div>
  <div class="mat-headline-5 fw-700 mb-24 mt-6">{{'CAPABILITIES.OPTIONAL_CAPABILITIES' | transloco}} </div>
  <div class="flex flex-row flex-wrap gap-x-4 capability-selected">
    <div *ngFor="let capability of selectedCapabilities" class="w-25-percent">
      <div class="flex flex-col capability-card selected p-24 h-200 mb-24">
        <div class="mat-headline-5 mb-20">{{capability.name | titlecase}}</div>
        <div class="flex mb-12 mat-subtitle-2">
          {{'CAPABILITIES.VERSION' | transloco}}: {{capability.version}}
        </div>
        <button class="basic-button w-max-content capability-link mat-subtitle-2 fw-400 mb-0">{{'CAPABILITIES.VIEW' | transloco}}</button>
      </div>
    </div>
  </div>
</div>
